import React, { FC, ReactNode } from 'react'
import './icon.scss'

export const ProfilefillIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container'>
      <img
        srcSet={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/c3776945d98b49af9156036e2bd6c1b1_IS24_ProfileFill.png'
        }
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/c3776945d98b49af9156036e2bd6c1b1_IS24_ProfileFill.png'
        }
        width={128}
        height={128}
        alt={''}
      />
    </div>
  )
}
